import Alpine from 'alpinejs';
import axios from '../../config/axios.js';

const emptyForm = () => ({
  title: '',
  theme: '',
  description: '',
  requirements: '',
  prize_description: '',
  duration_days: 7,
  starts_at: '',
  ends_at: '',
  winner_coins: 500,
  runner_up_coins: 200,
  third_coins: 100,
  winner_xp: 300,
  runner_up_xp: 150,
  third_xp: 75,
});

function createKasirBattle() {
  return {
    battles: [],
    modal: false,
    detailOpen: false,
    detail: null,
    busy: false,
    form: emptyForm(),

    init() {
      try {
        const cfg = JSON.parse(this.$el.getAttribute('data-config') || '{}');
        this.battles = Array.isArray(cfg.battles) ? cfg.battles : [];
      } catch (e) {
        console.error('kasirBattle config', e);
        this.battles = [];
      }
    },

    openCreate() {
      this.form = emptyForm();
      const start = new Date();
      this.form.starts_at = this.toLocalInput(start);
      this.modal = true;
    },

    toLocalInput(d) {
      const pad = (n) => String(n).padStart(2, '0');
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },

    closeModals() {
      this.modal = false;
      this.detailOpen = false;
      this.detail = null;
    },

    async save() {
      if (!this.form.title?.trim()) {
        window.toast?.('Judul wajib diisi.', 'error');
        return;
      }

      this.busy = true;
      try {
        const payload = {
          title: this.form.title,
          theme: this.form.theme || null,
          description: this.form.description || null,
          requirements: this.form.requirements || null,
          prize_description: this.form.prize_description || null,
          duration_days: Number(this.form.duration_days) || 7,
          starts_at: this.form.starts_at || null,
          ends_at: this.form.ends_at || null,
          winner_coins: Number(this.form.winner_coins) || 0,
          runner_up_coins: Number(this.form.runner_up_coins) || 0,
          third_coins: Number(this.form.third_coins) || 0,
          winner_xp: Number(this.form.winner_xp) || 0,
          runner_up_xp: Number(this.form.runner_up_xp) || 0,
          third_xp: Number(this.form.third_xp) || 0,
        };
        const { data } = await axios.post('/api/v1/kasir/engagement/battles', payload);
        this.battles.unshift({ ...(data.data || {}), entries_count: 0, votes_count: 0 });
        this.modal = false;
        window.toast?.(data.message || 'Battle dibuat & creator dinotifikasi.', 'success');
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal membuat battle.', 'error');
      } finally {
        this.busy = false;
      }
    },

    async openDetail(b) {
      this.busy = true;
      try {
        const { data } = await axios.get(`/api/v1/kasir/engagement/battles/${b.id}`);
        this.detail = data.data;
        this.detailOpen = true;
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal memuat detail.', 'error');
      } finally {
        this.busy = false;
      }
    },

    async finalize(b) {
      const ok = window.confirmDialog
        ? await window.confirmDialog({
            title: 'Finalize battle?',
            message: 'Juara 1–3 mendapat poin & XP. Notifikasi dikirim ke creator.',
            confirmText: 'Finalize',
          })
        : window.confirm('Finalize battle ini?');
      if (!ok) return;

      this.busy = true;
      try {
        const { data } = await axios.post(`/api/v1/kasir/engagement/battles/${b.id}/finalize`);
        b.status = 'closed';
        if (data.data) {
          this.detail = data.data;
          this.detailOpen = true;
        }
        const idx = this.battles.findIndex((x) => x.id === b.id);
        if (idx >= 0) this.battles[idx].status = 'closed';
        window.toast?.(data.message || 'Battle difinalisasi.', 'success');
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal finalize.', 'error');
      } finally {
        this.busy = false;
      }
    },
  };
}

Alpine.data('kasirBattle', createKasirBattle);
